export const formatted_bio = (text, cut_limit = 250) => {
    const replaced = text.replace(/<([^>]+)>/gi, "");
    if (replaced.length < cut_limit || cut_limit === 0) return replaced;
    return replaced.substring(0, cut_limit) + "...";
}